export default __webpack_public_path__ + "static/media/working-from-home.a9384b94.md";